var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sync"},[_c('el-dialog',{attrs:{"close-on-click-modal":false,"title":"地址智能识别","width":"600px","visible":_vm.visible,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',[_c('el-input',{attrs:{"type":"textarea","rows":8,"placeholder":`1、国外地址格式：
Sally Deming
33 SMOKE RIDGE RD
QUEENSBURY, NY 12804-7943
美国 
2、国内地址格式：
清远市清城区石角镇美林湖大东路口佰仹公司 郑万顺 15345785872`},model:{value:(_vm.textarea),callback:function ($$v) {_vm.textarea=$$v},expression:"textarea"}})],1),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticStyle:{"float":"left"},attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.handleCopy(`1、国外地址格式：
Sally Deming
33 SMOKE RIDGE RD
QUEENSBURY, NY 12804-7943
美国 
2、国内地址格式：
清远市清城区石角镇美林湖大东路口佰仹公司 郑万顺 15345785872`)}}},[_vm._v("复制样例")]),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.handleClose}},[_vm._v("返回")]),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.sureImport}},[_vm._v(" 确定 ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }